var alma;
(function($) {
  "use strict";
  alma = (function() {
    return {
      init: function() {
        // Header
        this.shoppingCart();
        this.popupNewsletter();
        this.fixedHeader();
        this.menu();
        this.search();
        this.mobileMenu();

        // Home Sections
        if($("body.index").length > 0) {
          this.slider();
          this.homeProducts();
          this.programme();
          this.journal();
        }

        // Collection page
        if($("body.collection").length > 0 || $("body.collection_programme").length > 0) {
          this.collectionPage();
          this.collectionPageFilters();
        }

        // Product page
        if($("body.product").length > 0) {
          this.productImages();
          this.relatedProducts();
          this.manageForm();
          this.productTabs();
          this.sizePopup();
        }

        // Cart page
        if($("#cart").length > 0) {
          this.cartPage();
        }

        // Blog page
        if($("body.blog").length > 0) {
          this.blogPage();
        }

        // Article page
        if($("#article").length > 0) {
          this.articlePage();
        }

        // Article theatre page
        if($("#article-theatre").length > 0) {
          this.articleTheatrePage();
        }

        // Pages
        if($("body.page_customer_care, body.page_contact, body.page_faq").length > 0) {
          this.pageHelp();
        }
        if($("body.page_about").length > 0) {
          this.pageAbout();
        }
        if($("#login").length > 0 || $("#account").length > 0) {
          this.accountPage();
        }
        if($("body.page_capsule").length > 0) {
          this.capsulePage();
        }

        // Scripts, effects
        this.lazyImages();
        this.addToCartGrid();
        this.changeQuantity();
        this.countdown();
        this.productGridImagesCarousel();
      },

      // Header
      shoppingCart: function() {
        $("body").on("click", "header .right ul li.cart .cart-count, header .right ul li.cart .cart-content .continue-shopping a", function () {
          if($("header .right ul li.cart").hasClass("active")) {
            $("header .right ul li.cart").removeClass("active");
          } else {
            $("header .right ul li.cart").addClass("active");
          }
          return false;
        });
        $("body").on("click", ".close-cart", function () {
          $("header .right .cart").removeClass("active");
        });
      },

      popupNewsletter: function() {
        if($("#newsletter").length > 0) {
          if(!$.cookie('newsletter')) {
            setTimeout(function () {
              $("#newsletter").addClass("active");
            }, $("#newsletter").attr("data-show-after"));
          } else {
            $("#newsletter").hide();
          }

          $("#newsletter .close-newsletter").click(function () {
            $.cookie('newsletter', 'true', { expires : 72000 });
            $("#newsletter").removeClass("active");
            return false;
          });
        }
      },

      fixedHeader: function() {
        $(window).on("resize scroll", function() {
          if($(window).scrollTop() > 100) {
            $("header").addClass("fixed");
          } else {
            $("header").removeClass("fixed");
          }
        });
      },

      menu: function() {
        var sub_menu_hover = false;
        $("header .menu .sub-menu").hover(function () {
          sub_menu_hover = true;
        }, function() {
          sub_menu_hover = false;
          setTimeout(function () {
            if(sub_menu_hover == false) {
              $("header .menu .sub-menu").stop().animate({ height: '0' }, 300);
              setTimeout(function () { 
                if($("header .menu .sub-menu").height() === 0){
                  $("header .menu .sub-menu, header .menu .sub-menu > div").removeClass("active").removeClass("show"); 
                }
              }, 301);
            }
          }, 200);
        });
        $("header .menu .navbar-nav .nav-item .nav-link").hover(function () {
          var menu_index = $(this).parent().attr("data-index");
          if($("header .menu .sub-menu > div[data-index='" + menu_index + "']").length > 0) {
            sub_menu_hover = true;
            $("header .menu .sub-menu").addClass("active");
            $("header .menu .sub-menu > div").removeClass("active").removeClass("show");
            $("header .menu .sub-menu > div[data-index='" + menu_index + "']").addClass("active");
            setTimeout(function () { $("header .menu .sub-menu > div[data-index='" + menu_index + "']").addClass("show"); }, 50);
            var curHeight = $("header .menu .sub-menu").height(),
                autoHeight = $("header .menu .sub-menu").css('height', 'auto').height();
                $("header .menu .sub-menu").height(curHeight);
                $("header .menu .sub-menu").stop().animate({ height: autoHeight }, 300);
          }
        }, function() {
          sub_menu_hover = false;
          setTimeout(function () {
            if(sub_menu_hover == false) {
              $("header .menu .sub-menu").stop().animate({ height: '0' }, 300);
              setTimeout(function () { 
                if($("header .menu .sub-menu").height() === 0){
                  $("header .menu .sub-menu, header .menu .sub-menu > div").removeClass("active").removeClass("show"); 
                }
              }, 301);
            }
          }, 200);
        });
        $("header video").each(function() {
          this.controls = false;
        });
      },

      mobileMenu: function() {
        $("header .open-menu").click(function () {
          if($("header .mobile-menu").hasClass("active")) {
            $("header .mobile-menu").stop().animate({ height: '0' }, 300);
            setTimeout(function () { 
               $("header .mobile-menu").removeClass("active").removeClass("show"); 
            }, 301);
          } else {
            $("header .mobile-menu").addClass("active");
            var autoHeight = $("header .mobile-menu").css('height', 'auto').height();
            $("header .mobile-menu").height("0px");
            $("header .mobile-menu").stop().animate({ height: autoHeight }, 300);
          }
        });
        $("header .menu .mobile-menu .mobile-nav li a").click(function () {
          var menu_index = $(this).parent().attr("data-index");
          if($("header .menu .sub-menu > div[data-index='" + menu_index + "']").length > 0) {
            $("header .menu .sub-menu").addClass("active");
            $("header .menu .sub-menu > div").removeClass("active").removeClass("show");
            $("header .menu .sub-menu > div[data-index='" + menu_index + "']").addClass("active");
            setTimeout(function () { $("header .menu .sub-menu > div[data-index='" + menu_index + "']").addClass("show"); }, 50);
            return false;
          }
        });
        $("header .menu .sub-menu .back").click(function () {
          $("header .menu .sub-menu, header .menu .sub-menu > div").removeClass("active").removeClass("show"); 
        });
        $("header .menu .sub-menu .links>li>a span").click(function () {
          if($(this).parent().parent().hasClass("active")) {
            $(this).parent().parent().removeClass("active");
          } else {
            $(this).parent().parent().addClass("active");
          }
          return false;
        });
      },

      search: function() {
        $("header .right ul li.search > a").click(function () {
          $(this).parent().addClass("active");
          if($(this).parent().find(".search-content").height() === 0){
            var curHeight = $(this).parent().find(".search-content").height(),
                autoHeight = $(this).parent().find(".search-content").css('height', 'auto').height();
                $(this).parent().find(".search-content").height(curHeight);
                $(this).parent().find(".search-content").stop().animate({ height: autoHeight }, 300);
          } else {
            $(this).parent().find(".search-content").stop().animate({ height: '0' }, 300);
            var element = $(this).parent();
            setTimeout(function () { $(element).removeClass("active"); }, 301);
          }
          return false;
        });
      },

      // Home Sections
      slider: function() {
        function setHeight() {
          $(window).on("load", function() {
            $("#slider .item img, #slider .item video, #slider, #slider .item .vimeo-wrapper").height($(window).outerHeight());
          });
          $(window).on("load resize", function() {
            if($(window).width() > 767) {
              $("#slider .item img, #slider .item video, #slider, #slider .item .vimeo-wrapper").height($(window).outerHeight());
            }
          });
        }

        function video() {
          $("#slider video").each(function() {
            this.controls = false;
          });
          if($("#slider video, #slider iframe").length > 0) {
            $("#slider video").each(function() {
              $(this).get(0).play();
            });
            setTimeout(function () {
              $("#slider iframe").parent().parent().addClass("active");
              $("#slider video").parent().addClass("active");
            }, 1500);
          }
        }

        $('#slider .owl-carousel').owlCarousel({
          items: 1,
          margin: 0,
          nav: true,
          loop: false,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          autoplay: true,
          autoplayTimeout: 12000
        });

        setHeight();
        video();
      },

      homeProducts: function() {
        function manageScroll() {
          var carousel = false;
          $('#home-products .home-products-carousel').on('click', '.owl-item.active + .owl-item:not(.active) .product-item, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) .product-item, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .product-item, .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .product-item, .owl-item.active + .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .product-item', function(e) {
            $('#home-products .home-products-carousel').trigger('next.owl.carousel');
            carousel = true;
            setTimeout(function () {
              carousel = false;
            }, 100);
          });
          $('#home-products .home-products-carousel').on('click', '.owl-item:not(.active) .product-item', function() {
            if(carousel == false) {
              $('#home-products .home-products-carousel').trigger('prev.owl.carousel');
            }
          });
          $('#home-products .home-products-carousel').on('click', '.owl-item:not(.active) .product-item a.item', function(e) {
            e.preventDefault();
          });
        }

        $('#home-products .home-products-carousel').owlCarousel({
          items: 3,
          margin: 28,
          nav: true,
          autoplay: false,
          dotsData: true,
          loop: false,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 3
            }
          }
        });

        manageScroll();
      },

      programme: function() {
        function counter() {
          var counter = 100;
          setInterval(function () {
            if(counter > 0) {
              counter = counter-1;
              $("#programme .counter p span").html(counter);
            }
          }, 1000);
          $("#programme video").each(function () {
            this.controls = false;
          });
        }

        $('#programme .programme-carousel').owlCarousel({
          items: 2,
          margin: 28,
          nav: true,
          autoplay: false,
          responsive: {
            0: {
              items: 1
            },
            992: {
              items: 2
            }
          }
        });

        $('#programme .programme-carousel').on('click', '.owl-item.active .product-item .item', function(e) {
          window.location.href = $(this).attr("data-href");
        });

        counter();
      },

      journal: function() {
        function manageScroll() {
          var carousel = false;
          $('#journal .journal-carousel').on('click', '.owl-item.active .article-item', function(e) {
            window.location.href = $(this).attr("data-href");
          });
          $('#journal .journal-carousel').on('click', '.owl-item.active + .owl-item:not(.active) .article-item, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) .article-item, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .article-item, .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .article-item, .owl-item.active + .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .article-item', function(e) {
            $('#journal .journal-carousel').trigger('next.owl.carousel');
            carousel = true;
            setTimeout(function () {
              carousel = false;
            }, 100);
          });
          $('#journal .journal-carousel').on('click', '.owl-item:not(.active) .article-item', function() {
            if(carousel == false) {
              $('#journal .journal-carousel').trigger('prev.owl.carousel');
            }
          });
        }

        $('#journal .journal-carousel').owlCarousel({
          items: 3,
          margin: 28,
          nav: true,
          autoplay: false,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 3
            }
          }
        });

        manageScroll();
      },

      // Collection page
      collectionPage: function() {
        function loadMoreProducts() {
          $("body").on("click", "#shop #more .button", function () {
            $("#shop #more").addClass("loading");
            $.ajax({
              url: $(this).attr("href"),
              type: 'GET'
            }).done(function(data) {
              $("#shop #more").remove();
              $('.filter-products').append($(data).find('.filter-products').html());
              alma.lazyImages();
              alma.productGridImagesCarousel();
              alma.countdown();
            });
            return false;
          });
        }

        loadMoreProducts();
      },

      collectionPageFilters: function() {
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".sort-by").find("a.active").attr("data-value");
        var tags = [];
        $(".field input").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if(Shopify.queryParams.constraint == '') {
            return $(".filter-products").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
          } else {
            return $(".filter-products").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $("body").addClass("is_loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".filter-products").html($(result).find(".filter-products").html());
              $("body").removeClass("is_loading");
              alma.lazyImages();
              alma.productGridImagesCarousel();
              alma.countdown();
            },
            error: function() {
              $("body").removeClass("is_loading");
            }
          })
        }

        $("#shop .filters .apply a").click(function () {
          var tags = [];
          $("input[name='tag']").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          $("#shop .filters .column").removeClass("active");
          $("#shop .filters .close-content").removeClass("active");
          return false;
        });

        $("body").on("click", ".sort-by a", function(y) {
          $(".sort-by a").removeClass("active");
          $(this).addClass("active");
          Shopify.queryParams.sort_by = $(this).attr("data-value");
          filterGetContent(filterCreateUrl());
          $("#shop .filters .column").removeClass("active");
          $("#shop .filters .close-content").removeClass("active");
          return false;
        });

        $("#shop .filters .column .title").click(function () {
          if($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
            $("#shop .filters .close-content").removeClass("active");
          } else {
            $("#shop .filters .column").removeClass("active");
            $(this).parent().addClass("active");
            $("#shop .filters .close-content").addClass("active");
          }
        });

        $("#shop .filters .close-content").click(function () {
          $("#shop .filters .column").removeClass("active");
          $("#shop .filters .close-content").removeClass("active");
        });
      },

      // Product page
      productImages: function() {
        $("#product .product-template .left .owl-carousel").owlCarousel({
          items: 1,
          margin: 0,
          nav: true,
          autoplay: false,
          autoHeight: true
        });

        function manageThumbnails() {
          $("#product .product-template .left .thumbnails .item").click(function () {
            var index = $(this).index();
            $("#product .product-template .left .owl-carousel").trigger('to.owl.carousel', [index, 500]);
          });
          $("#product .product-template .left .owl-carousel").on('changed.owl.carousel', function(event) {
            $("#product .product-template .left .thumbnails .item").removeClass("current");
            $("#product .product-template .left .thumbnails .item").eq(event.item.index).addClass("current");
          });
          $("#product .zoom .zoom-thumbnails .item").click(function () {
            var index = $(this).index() + 1;
            $("#product .zoom").scrollTo(".zoom-images .item:nth-child(" + index + ")");
          });
        }

        function manageZoom() {
          $("#product .zoom").on("scroll", function(e){
            console.log("product scrolling");   
            $("#product .zoom .zoom-images .item").each(function () {
              if($(this).isInViewport()) {
                $("#product .zoom .zoom-thumbnails .item").removeClass("current");
                $("#product .zoom .zoom-thumbnails .item").eq($(this).index()).addClass("current");
              }
            }); 
          });
          $("#product .zoom .zoom-images .item").click(function (event) {
            if($(this).hasClass("zoom-in")) {
              $(this).removeClass("zoom-in");
            } else {
              var widthElement = $(this).outerWidth();
              var whereClickedX = event.pageX - $(this).offset().left;
              var heightElement = $(this).outerHeight();
              var whereClickedY = event.pageY - $(this).offset().top;
              $(this).find("img").css("transform-origin", (whereClickedX/widthElement*100) + "% " + (whereClickedY/heightElement*100) + "%");
              $(this).addClass("zoom-in");
            }
          });
        }

        function openZoom() {
          $("#product .product-template .left .images .owl-carousel .item img").click(function () {
            $("body").css("overflow", "hidden");
            $("#product .zoom").addClass("active");
            setTimeout(function () {
              $("#product .zoom").addClass("show");
            }, 50);
            var index = $("#product .product-template .left .thumbnails .item.current").index() + 1;
            $("#product .zoom").scrollToWithoutAnimation(".zoom-images .item:nth-child(" + index + ")");
          });
          $("#product .product-template.product-programme-template .left .desktop-images .item").click(function () {
            $("body").css("overflow", "hidden");
            $("#product .zoom").addClass("active");
            setTimeout(function () {
              $("#product .zoom").addClass("show");
            }, 50);
            var index = $(this).parent().index() + 1;
            $("#product .zoom").scrollToWithoutAnimation(".zoom-images .item:nth-child(" + index + ")");
          });
        }

        function closeZoom() {
          $("#product .zoom .close-zoom").click(function () {
            $("#product .zoom").removeClass("show");
            setTimeout(function () {
              $("#product .zoom").removeClass("active");
              $("body").css("overflow", "visible");
            }, 401);
          });
          $(document).keyup(function(e) {
            if (e.key === "Escape") {
              $("#product .zoom").removeClass("show");
              setTimeout(function () {
                $("#product .zoom").removeClass("active");
                $("body").css("overflow", "visible");
              }, 401);
            }
          });
        }

        openZoom();
        closeZoom();
        manageThumbnails();
        manageZoom();
      },

      relatedProducts: function() {
        if($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              alma.homeProducts();
              alma.lazyImages();
              alma.countdown();
              alma.productGridImagesCarousel();
            }
          };
          request.send();
        }
      },

      manageForm: function() {
        function addToCart() {
          $("#product .product-template .right .form-button, #product .product-bar .right .form-button.add-to-cart").addClass("loading");
          var quantity = $("#product .product-template .right form .quantity input").val();
          if(isNaN(quantity)) { quantity = 1; }
          var id = $("#product-select").val();
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
              alma.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              alma.refreshCart();
            }
          });
        }

        function variants() {
          var data = JSON.parse(document.getElementById('ProductJson').innerHTML);
          var selectCallback = function(variant, selector) {
            if (variant) {
              if (variant.available) {
                $("#product .product-template .right form .form-button.add-to-cart, #product .product-bar .right .form-button.add-to-cart").removeClass("d-none");
                $("#product .product-template .right form .form-button.out-of-stock, #product .product-bar .right .form-button.out-of-stock").addClass("d-none");
              } else {
                $("#product .product-template .right form .form-button.add-to-cart, #product .product-bar .right .form-button.add-to-cart").addClass("d-none");
                $("#product .product-template .right form .form-button.out-of-stock, #product .product-bar .right .form-button.out-of-stock").removeClass("d-none");
              }
              if(variant.compare_at_price > variant.price) {
                $('#product .product-template .right .wrap .main-price .price-old').removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $('#product .product-template .right .wrap .main-price .price-new, #product .product-bar .left .price-new').html(Shopify.formatMoney(variant.price));
              } else {
                $('#product .product-template .right .wrap .main-price .price-old').addClass("d-none")
                $('#product .product-template .right .wrap .main-price .price-new, #product .product-bar .left .price-new').html(Shopify.formatMoney(variant.price));
              }
            } else {
              $("#product .product-template .right form .form-button.add-to-cart, #product .product-bar .right .form-button.add-to-cart").addClass("d-none");
              $("#product .product-template .right form .form-button.out-of-stock, #product .product-bar .right .form-button.out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function($) {
            new Shopify.OptionSelectors("product-select", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
          });
        }

        $("#product .product-template .right form .form-button.add-to-cart").click(function () {
          addToCart();
        });

        $("#product .product-bar .right .form-button.add-to-cart").click(function () {
          $("#product .product-template .right form .form-button.add-to-cart").click();
        });

        $("body").on("click", "#product .product-template .right form .form-button.out-of-stock, #product .product-bar .right .form-button.out-of-stock", function() {
          $(".bis-reset").click();
        });

        $("#product .product-template .right .options .option .value").click(function () {
          $(this).parent().find(".value").removeClass("active");
          $(this).addClass("active");
          var option = $(this).parent().attr("data-option");
          var value = $(this).attr("data-value");
          var index = $(this).index();
          $("#product .product-bar .right .options .option[data-option='" + option + "'] .value").removeClass("active");
          $("#product .product-bar .right .options .option[data-option='" + option + "'] .value").eq(index).addClass("active");
          $("#product-variants select[data-option='" + option + "']").val(value).change();
        });

        $("#product .product-bar .right .options .option .value").click(function () {
          var option = $(this).parent().attr("data-option");
          var index = $(this).index();
          $("#product .product-template .right .options .option[data-option='" + option + "'] .value").eq(index).click();
        });

        variants();

        // Product bar
        $(window).scroll(function() {
          var scrollTop = $(window).scrollTop();
          if(scrollTop > $("#product .product-template .right .form-button.add-to-cart").offset().top) {
            $(".product-bar").addClass("active"); 
          } else {
            $(".product-bar").removeClass("active");
          }
        });
      },

      productTabs: function() {
        $("#product .more-information").click(function () {
          $('html, body').animate({
            scrollTop: $(".product-tabs").offset().top - $("header").outerHeight()
          }, 2000);
          return false;
        });
        $("#product .product-tabs .tabs-nav li a").click(function () {
          var index = $(this).parent().index();
          $("#product .product-tabs .tabs-nav li a").removeClass("active");
          $(this).addClass("active");
          $("#product .product-tabs .tabs-content .tab-content").removeClass("active").removeClass("show");
          $("#product .product-tabs .tabs-content .tab-content").eq(index).addClass("active");
          setTimeout(function () {
            $("#product .product-tabs .tabs-content .tab-content").eq(index).addClass("show");
          }, 50);
          return false;
        });
      },  

      sizePopup: function() {
        $("#product .product-template .right .options .modal-size .content ul.change-table li a").click(function () {
          $("#product .product-template .right .options .modal-size .content ul.change-table li a").removeClass("active");
          $(this).addClass("active");
          $("#product .product-template .right .options .modal-size .content .table-cm, #product .product-template .right .options .modal-size .content .table-inches").removeClass("active");
          $("#product .product-template .right .options .modal-size .content .table-" + $(this).attr("data-table")).addClass("active");
          return false;
        });
        $("#product .product-template .right .options .size-popup").click(function () {
          $("body").css("overflow", "hidden");
          $("#product .product-template .right .options .close-modal-size, #product .product-template .right .options .modal-size").addClass("active");
          setTimeout(function () {
            $("#product .product-template .right .options .close-modal-size, #product .product-template .right .options .modal-size").addClass("show");
          }, 100);
        });
        $("#product .product-template .right .options .modal-size .content .close-modal-size-2 svg, #product .product-template .right .options .close-modal-size").click(function () {
          $("body").css("overflow", "visible");
          $("#product .product-template .right .options .close-modal-size, #product .product-template .right .options .modal-size").removeClass("show");
          setTimeout(function () {
            $("#product .product-template .right .options .close-modal-size, #product .product-template .right .options .modal-size").removeClass("active");
          }, 401);
          return false;
        });
      },

      // Cart Page
      cartPage: function() {
        $("#cart .custom-container .cart-summary .cart .table tbody tr td.price .edit").click(function () {
          $(this).parent().parent().parent().addClass("active");
          var level = $(this).parent().parent().parent().attr("data-level");
          $("#cart .custom-container .cart-summary .cart .table tbody tr.cart-update[data-level='" + level + "']").addClass("active");
          return false;
        });
        $("#cart .custom-container .cart-summary .cart .table tbody tr td.price .delete").click(function () {
          $(this).parent().parent().parent().removeClass("active");
          var level = $(this).parent().parent().parent().attr("data-level");
          $("#cart .custom-container .cart-summary .cart .table tbody tr.cart-update[data-level='" + level + "']").removeClass("active");
          return false;
        });
        $(".quantity_up").click(function () {
            var q_val_up = parseInt($(this).parent().find("input").val());
            if(isNaN(q_val_up)) {
                q_val_up = 0;
            }
            $(this).parent().find("input").val(q_val_up+1).keyup(); 
            $("#cart .custom-container .cart-summary .summary button[name='update']").addClass("active");
            return false;
        });
        $(".quantity_down").click(function () {
            var q_val_up = parseInt($(this).parent().find("input").val());
            if(isNaN(q_val_up)) {
                q_val_up = 0;
            }
            if(q_val_up > 1) {
                $(this).parent().find("input").val(q_val_up-1).keyup(); 
            }
            $("#cart .custom-container .cart-summary .summary button[name='update']").addClass("active");
            return false;
        });
        $(".quantity_up2").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
              q_val_up = 0;
          }
          $(this).parent().find("input").val(q_val_up+1).keyup(); 
          var quantity = $(this).parent().parent().parent().attr("data-level");
          $(this).parent().parent().parent().parent().find("tr[data-level='" + quantity + "'] input").val(q_val_up+1).keyup(); 
          $("#cart .custom-container .cart-summary .summary button[name='update']").addClass("active");
          return false;
        });
        $(".quantity_down2").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if(isNaN(q_val_up)) {
              q_val_up = 0;
          }
          if(q_val_up > 1) {
              $(this).parent().find("input").val(q_val_up-1).keyup(); 
              var quantity = $(this).parent().parent().parent().attr("data-level");
              $(this).parent().parent().parent().parent().find("tr[data-level='" + quantity + "'] input").val(q_val_up-1).keyup(); 
          }
          $("#cart .custom-container .cart-summary .summary button[name='update']").addClass("active");
          return false;
        });
      },

      // Blog page
      blogPage: function() {
        function loadMorePosts() {
          $("body").on("click", "#blog #more .button", function () {
            $("#blog #more").addClass("loading");
            $.ajax({
              url: $(this).attr("href"),
              type: 'GET'
            }).done(function(data) {
              $("#blog #more").remove();
              $('.filter-articles').append($(data).find('.filter-articles').html());
              alma.lazyImages();
            });
            return false;
          });
        }

        loadMorePosts();
      },

      // Article page
      articlePage: function() {
        $("#article").waitForImages(function() {
          var msnry = new Masonry('.masonry-grid', {

          });
        });
        $('.masonry-grid').magnificPopup({
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1]
          }
        });
      },

      // Article theatre page
      articleTheatrePage: function() {
        $("#article-theatre .play-video .play").click(function() {
          $("#article-theatre .video").addClass("active");
          $("#article-theatre .play-video").addClass("unactive");
          $("#article-theatre video").each(function () {
            $(this).trigger('play');
            this.controls = false; 
          });
          $("#article-theatre iframe").each(function() {
            var iframe = $(this)[0],
                player = $f(iframe);
            player.addEvent('ready', function() {
              player.api('play');
            });
          });
        });
      },

      // Pages
      pageHelp: function() {
        $("#help .d-flex .left h2").click(function () {
          if($(this).parent().hasClass("active")) {
            $("#help .d-flex .left .collapse").stop().animate({ height: '0' }, 300);
            setTimeout(function () {
              $("#help .d-flex .left").removeClass("active");
            }, 301);
          } else {
            $(this).parent().addClass("active");
            var autoHeight = $("#help .d-flex .left .collapse").css('height', 'auto').height();
                $("#help .d-flex .left .collapse").height("0px");
                $("#help .d-flex .left .collapse").stop().animate({ height: autoHeight }, 300);
          }
          return false;
        });
        $("#help .d-flex .right .content .faq .answers .answer .question").click(function () {
          if($(this).parent().hasClass("active")) {
            $(this).parent().find(".content").stop().animate({ height: '0' }, 300);
            var that = $(this);
            setTimeout(function () {
              $(that).parent().removeClass("active");
            }, 301);
          } else {
            $(this).parent().addClass("active");
            var autoHeight = $(this).parent().find(".content").css('height', 'auto').height();
                $(this).parent().find(".content").height("0px");
                $(this).parent().find(".content").stop().animate({ height: autoHeight }, 300);
          }
          return false;
        });
      },

      pageAbout: function() {
        $("#about-us-intro .right").waitForImages(function() {
          setTimeout(function () {
            $("#about-us-intro .right .first-image, #about-us-intro .right .second-image, #about-us-intro .right .third-image").addClass("active");
          }, 400);
        });
        $("#about-us-images-carousel .owl-carousel").owlCarousel({
          items: 8,
          margin: 0,
          nav: false,
          loop: true,
          autoplay: true,
          responsive: {
            0: {
              items: 4
            },
            768: {
              items: 6
            },
            992: {
              items: 8
            }
          }
        });
      },

      accountPage: function() {
        function showRecoverPasswordForm() {
          return $("#recover-password").fadeIn(), $("#customer-login").hide(), window.location.hash="#recover";
        }

        function showLoginForm() {
          return $("#recover-password").hide(), $("#customer-login").fadeIn(), window.location.hash="";
        }

        $("#forgot-password a").click(function() {
          showRecoverPasswordForm();
        });

        $("#recover-password a.cancel").click(function() {
          showLoginForm();
        });

        if("#recover" == window.location.hash) {
          showRecoverPasswordForm()
        } else {
          showLoginForm();
        }

        $("#account .d-flex .left h2").click(function () {
          if($(this).parent().hasClass("active")) {
            $("#account .d-flex .left .collapse").stop().animate({ height: '0' }, 300);
            setTimeout(function () {
              $("#account .d-flex .left").removeClass("active");
            }, 301);
          } else {
            $(this).parent().addClass("active");
            var autoHeight = $("#account .d-flex .left .collapse").css('height', 'auto').height();
                $("#account .d-flex .left .collapse").height("0px");
                $("#account .d-flex .left .collapse").stop().animate({ height: autoHeight }, 300);
          }
          return false;
        });
      },

      capsulePage: function() {
        $("#capsule video, #capsule-hero video").each(function () {
          this.controls = false; 
        });
      },

      // Scripts, effects
      lazyImages: function() {
        function isRetina() {
          return window.devicePixelRatio > 1;
        }

        function isMobile() {
          if($(document).outerWidth() > 767) { return false; } else { return true; }
        }

        $(".lazy-img").each(function () {
          var element = $(this);
          var interval = setInterval(function () {
            if($(element).isInViewport() || $(element).hasClass("immediately")) {
              var src = $(element).attr("data-src");
              if(isRetina() && isMobile() && $(element).attr("data-retina-mobile-src") != undefined) src = $(element).attr("data-retina-mobile-src");
              if(!isRetina() && isMobile() && $(element).attr("data-mobile-src") != undefined) src = $(element).attr("data-mobile-src");
              if(isRetina() && !isMobile() && $(element).attr("data-retina-src") != undefined) src = $(element).attr("data-retina-src");
              if(src == '') src = $(element).attr("data-src");
              $(element).attr("src", src);
              $(element).parent().waitForImages(function() {
                $(element).parent().addClass("active");
                clearInterval(interval);
              });
            }
          }, 100);
        });
      },

      addToCartGrid: function() {
        $(document).on('click', '.variants button, .add-variant', function(){
          var quantity = $(this).attr("data-quantity");
          var id = $(this).attr("data-variant-id");
          $(this).addClass("loading");
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
              alma.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              alma.refreshCart();
            }
          });
          return false;
        });
      },

      refreshCart: function() {
        $('header .right .cart').addClass("loading");
        $('header .right .cart .cart-content').load('/cart #cart-content', function() {
          $('header .right .cart').removeClass("loading");
          $("#product .product-template .right .form-button, .product-item .meta .variants button, .add-variant, #product .product-bar .right .form-button.add-to-cart").removeClass("loading");
          setTimeout(function () {
            $('header .right .cart').addClass("active");
          }, 400);
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('header .right ul li.cart .cart-count').html(cart.item_count);
          //console.log(cart.items);
          var countryCode = $("#countrySelect").find(":selected").val();
          console.log(countryCode);
          for(var i=0; i < cart.item_count; i++){
            if(cart.items[i]){
            //	console.log(cart.items[i].product_title);
              zonos.quote({
                items: [{ price: cart.items[i].price, name: cart.items[i].product_title, url: cart.items[i].url, image: cart.items[i].image}],
                currencyCode: countryCode
              });
              
            }
          }
        });
        
      },

      changeQuantity: function() {
        $("body").on("click", "header .right ul li.cart .cart-content ul.items li .quantity a, header .right ul li.cart .cart-content ul.items li .quantity .remove a", function() {
          $('header .right .cart').addClass("loading");
          var id = $(this).attr("data-variant-id");
          var quantity = parseInt($(this).attr("data-quantity"));
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function() {
              alma.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              alma.refreshCart();
            }
          });
          return false;
        });
      },

      countdown: function() {
        $(".countdown").each(function () {
          var countdown_day = new Date();
          countdown_day = new Date($(this).attr("data-year"), $(this).attr("data-month") - 1, $(this).attr("data-day"));
          if($(this).attr("data-hours") > 0) {
            countdown_day.setHours($(this).attr("data-hours"));
          }
          if($(this).attr("data-minutes") > 0) {
            countdown_day.setMinutes($(this).attr("data-minutes"));
          }
          $(this).countdown({ until: countdown_day });
        });
      },

      productGridImagesCarousel: function() {
        $(".splide").each(function () {
          new Splide(this, { drag: false }).mount();
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  alma.init();
  $.cookieBar({ fixed: true });
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      alma.init();
    }).on('shopify:section:unload', function() {
      alma.init();
    }).on('shopify:section:select', function() {
      alma.init();
    }).on('shopify:section:deselect', function() {
      alma.init();
    }).on('shopify:block:select', function() {
      alma.init();
    }).on('shopify:block:deselect', function() {
      alma.init();
    });
}